export default {
  mainFormContainer: {

  },
  contentContainer: {

  },
  childContainer: {
    paddingTop: '16px' ,
    borderLeft: '1px solid rgba(0,0,0,0.36)'
  }
}
